// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { ShapeElement } from './ShapeElement';
import { Double2D } from '../../../../../com/MetaPattern/MDA/Designer/Base/Double2D';
import { DiagramShape } from './DiagramShape';
import { NodeShape } from './NodeShape';
import { LineShape } from './LineShape';
/**
 * 容器图形 实体类
 * 容器图形定义容器，其他图形可以放置于容器中，线不能跨容器。容器可以嵌套
 */
export class ContainerShape extends ShapeElement {
  /** 名称 : 名称 */
  private _name: string;

  /** 设置：名称 */
  public get name() {
    return this._name;
  }

  /** 获取：名称 */
  public set name(value: string) {
    this._name = value;
  }

  /** 显示名称 : 显示名称 */
  private _displayName: string;

  /** 设置：显示名称 */
  public get displayName() {
    return this._displayName;
  }

  /** 获取：显示名称 */
  public set displayName(value: string) {
    this._displayName = value;
  }

  /** 简介 : 简介 */
  private _description: string;

  /** 设置：简介 */
  public get description() {
    return this._description;
  }

  /** 获取：简介 */
  public set description(value: string) {
    this._description = value;
  }

  /** IsVisible : 定义图形的可见性，false则隐藏图形 */
  private _isVisible: boolean;

  /** 设置：IsVisible */
  public get isVisible() {
    return this._isVisible;
  }

  /** 获取：IsVisible */
  public set isVisible(value: boolean) {
    this._isVisible = value;
  }

  /** IsExpend : 图形是否是展开状态，默认true，false代表容器整体收缩 */
  private _isExpend: boolean;

  /** 设置：IsExpend */
  public get isExpend() {
    return this._isExpend;
  }

  /** 获取：IsExpend */
  public set isExpend(value: boolean) {
    this._isExpend = value;
  }

  /** StartPoint : 定义图形的左上角点坐标 */
  private _startPoint: Double2D;

  /** 设置：StartPoint */
  public get startPoint() {
    return this._startPoint;
  }

  /** 获取：StartPoint */
  public set startPoint(value: Double2D) {
    this._startPoint = value;
  }

  /** CurSize : 定义图形的当前尺寸，如果没有改变则等于初始尺寸 */
  private _curSize: Double2D;

  /** 设置：CurSize */
  public get curSize() {
    return this._curSize;
  }

  /** 获取：CurSize */
  public set curSize(value: Double2D) {
    this._curSize = value;
  }

  /** IsLocked : 锁定的图形不能进行任何的编辑操作 */
  private _isLocked: boolean;

  /** 设置：IsLocked */
  public get isLocked() {
    return this._isLocked;
  }

  /** 获取：IsLocked */
  public set isLocked(value: boolean) {
    this._isLocked = value;
  }

  /** 图表 的ID */
  private _diagram_ID: string;

  /** 获取：图表 的ID */
  public get diagram_ID() {
    return this._diagram_ID;
  }

  /** 设置：图表 的ID */
  public set diagram_ID(value: string) {
    this._diagram_ID = value;
  }

  /** 图表  */
  private _diagram: DiagramShape;

  /** 获取：图表  */
  public get diagram() {
    return this._diagram;
  }

  /** 设置：图表  */
  public set diagram(value: DiagramShape) {
    this._diagram = value;
    if (value !== null) {
      this.diagram_ID = value.id;
    } else {
      this.diagram_ID = '';
    }
  }

  /** 父区域 的ID */
  private _parent_ID: string;

  /** 获取：父区域 的ID */
  public get parent_ID() {
    return this._parent_ID;
  }

  /** 设置：父区域 的ID */
  public set parent_ID(value: string) {
    this._parent_ID = value;
  }

  /** 父区域  */
  private _parent: ContainerShape;

  /** 获取：父区域  */
  public get parent() {
    return this._parent;
  }

  /** 设置：父区域  */
  public set parent(value: ContainerShape) {
    this._parent = value;
    if (value !== null) {
      this.parent_ID = value.id;
    } else {
      this.parent_ID = '';
    }
  }

  /** 节点图形 */
  private _nodeShapes: Array<NodeShape>;

  /** 获取：节点图形 */
  public get nodeShapes() {
    return this._nodeShapes;
  }

  /** 设置：节点图形 */
  public set nodeShapes(value: Array<NodeShape>) {
    this._nodeShapes = value;
  }

  /** 线图形 */
  private _lineShapes: Array<LineShape>;

  /** 获取：线图形 */
  public get lineShapes() {
    return this._lineShapes;
  }

  /** 设置：线图形 */
  public set lineShapes(value: Array<LineShape>) {
    this._lineShapes = value;
  }

  /** 子区域 */
  private _children: Array<ContainerShape>;

  /** 获取：子区域 */
  public get children() {
    return this._children;
  }

  /** 设置：子区域 */
  public set children(value: Array<ContainerShape>) {
    this._children = value;
  }

  constructor() {
    super();
    this._name = '';
    this._displayName = '';
    this._description = '';
    this._isVisible = true;
    this._isExpend = true;
    this._startPoint = new Double2D();
    this._curSize = new Double2D();
    this._isLocked = false;
    this._diagram_ID = '';
    this._diagram = null;
    this._parent_ID = '';
    this._parent = null;
    this._nodeShapes = new Array<NodeShape>();
    this._lineShapes = new Array<LineShape>();
    this._children = new Array<ContainerShape>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: ContainerShape, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.name = element.name;
      this.displayName = element.displayName;
      this.description = element.description;
      this.isVisible = element.isVisible;
      this.isExpend = element.isExpend;
      this.startPoint = element.startPoint;
      this.curSize = element.curSize;
      this.isLocked = element.isLocked;
      this.diagram_ID = element.diagram_ID;
      if (hasReference && element.diagram !== null) {
        this.diagram = element.diagram;
      }
      this.parent_ID = element.parent_ID;
      if (hasReference && element.parent !== null) {
        this.parent = element.parent;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.name = json.Name;
    this.displayName = json.DisplayName;
    this.description = json.Description;
    this.isVisible = json.IsVisible;
    this.isExpend = json.IsExpend;
    this.startPoint = new Double2D(json.StartPoint.X, json.StartPoint.Y);
    this.curSize = new Double2D(json.CurSize.X, json.CurSize.Y);
    this.isLocked = json.IsLocked;
    this.diagram_ID = json.Diagram_ID;
    // if (json.Diagram !== null) {
    //   this.diagram = DiagramShape.Create(json.Diagram);
    // }
    this.parent_ID = json.Parent_ID;
    // if (json.Parent !== null) {
    //   this.parent = ContainerShape.Create(json.Parent);
    // }
    if (json.NodeShapes && json.NodeShapes.length > 0) {
      json.NodeShapes.forEach((element: any) => {
        const nodeShape = NodeShape.Create(element);
        // nodeShape.container = this;
        this.nodeShapes.push(nodeShape);
      });
    }
    if (json.LineShapes && json.LineShapes.length > 0) {
      json.LineShapes.forEach((element: any) => {
        const lineShape = LineShape.Create(element);
        // lineShape.container = this;
        this.lineShapes.push(lineShape);
      });
    }
    if (json.Children && json.Children.length > 0) {
      json.Children.forEach((element: any) => {
        const containerShape = ContainerShape.Create(element);
        // containerShape.parent = this;
        this.children.push(containerShape);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Name = this.name;
    json.DisplayName = this.displayName;
    json.Description = this.description;
    json.IsVisible = this.isVisible;
    json.IsExpend = this.isExpend;
    json.StartPoint = {};
    json.StartPoint.X = this.startPoint.x;
    json.StartPoint.Y = this.startPoint.y;
    json.CurSize = {};
    json.CurSize.X = this.curSize.x;
    json.CurSize.Y = this.curSize.y;
    json.IsLocked = this.isLocked;
    json.Diagram_ID = this.diagram_ID;
    json.Parent_ID = this.parent_ID;
    if (this.nodeShapes && this.nodeShapes.length > 0) {
      json.NodeShapes = [];
      this.nodeShapes.forEach((element) => {
        json.NodeShapes.push(element.toJson());
      });
    }
    if (this.lineShapes && this.lineShapes.length > 0) {
      json.LineShapes = [];
      this.lineShapes.forEach((element) => {
        json.LineShapes.push(element.toJson());
      });
    }
    if (this.children && this.children.length > 0) {
      json.Children = [];
      this.children.forEach((element) => {
        json.Children.push(element.toJson());
      });
    }
  }

  static Create(json: any): ContainerShape {
    const containerShape = new ContainerShape();
    containerShape.Deserialize(json);
    containerShape.json = json;
    return containerShape;
  }
}
